'use strict';

var _default = require('fs');

module.exports = _default;
